import { DropdownChevron } from '@components'
import cn from '@integrations/classnames'
import { tr, useDropDownMenu } from 'mmfintech-commons'

import surfaceStyles from '../Layout/HeaderMenuSurface/HeaderMenuSurface.module.scss'
import styles from './MerchantSwitchMenu.module.scss'
import { useMerchantSwitch } from './useMerchantSwitch'

interface Props {
  hamburger?: boolean
}

function MerchantSwitchMenu({ hamburger = false }: Props) {
  const {
    merchantList,
    canSwitch,
    currentMerchantId,
    currentMerchantLabel: name,
    selectMerchantById
  } = useMerchantSwitch()

  const { visible, hideDropDown, toggleDropDown, setRef } = useDropDownMenu()

  function handleMerchantClick(merchantId: number) {
    hideDropDown()
    void selectMerchantById(merchantId)
  }

  if (canSwitch) {
    const currentMerchantName = name || tr('FRONTEND.HEADER.SWITCH_MERCHANT', 'Switch to')

    return (
      <div
        data-test='merchant-menu-wrapper'
        className={cn(
          surfaceStyles['header-menu-wrapper'],
          styles['merchant-switch-menu-wrapper'],
          'merchant-switch-menu-wrapper',
          {
            [styles['hamburger']]: hamburger,
            hamburger
          }
        )}
        ref={setRef}
      >
        <div
          className={cn(surfaceStyles['header-menu-trigger'], styles['menu-container'], 'menu-container', {
            opened: visible
          })}
          onClick={toggleDropDown}
        >
          <span className={cn(styles['icon-letter'], 'icon-letter', styles['active'], 'active')}>
            {currentMerchantName ? currentMerchantName.substring(0, 1) : '?'}
          </span>
          <span className={cn('name')}>{currentMerchantName}</span>
          <DropdownChevron className={cn('arrow')} expanded={visible} />
        </div>
        <div
          className={cn(
            surfaceStyles['header-menu-dropdown'],
            styles['menu-dropdown'],
            'menu-dropdown',
            'raised-frame-surface',
            'shadow-card',
            {
              [surfaceStyles['opened']]: visible,
              opened: visible
            }
          )}
          data-test='language-menu-content'
        >
          <ul className={cn(surfaceStyles['header-menu-list'], 'header-menu-list')} data-test='language-menu-list'>
            {merchantList.map((v) => (
              <li
                className={cn(surfaceStyles['header-menu-option'], 'dropdown-option')}
                key={v.merchantId}
                onClick={() => handleMerchantClick(v.merchantId)}
                data-test='merchant-menu-item'
              >
                <span
                  className={cn(styles['icon-letter'], 'icon-letter', {
                    [styles['active']]: v.merchantId === currentMerchantId,
                    active: v.merchantId === currentMerchantId
                  })}
                >
                  {v.displayName.substring(0, 1)}
                </span>
                {v.displayName}
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  }

  return null
}

export default MerchantSwitchMenu
